export default {
    language: 'fr-FR',
    navigation: 'Back',
    home: {
        title: 'Yacht Paint Calculator',
        subtitle:
            'Laissez-nous vous aider à choisir le meilleur système antifouling pour votre bateau et à calculer le volume nécessaire pour vos besoins.',
        findProduct: 'Trouvez le produit',
        calculateVolume: 'Calculer le volume'
    },
    find: {
        questions: {
            type: 'Choisissez votre <strong>type de bateau</strong>',
            material: 'Sélectionner les <strong>matériaux</strong> dont votre bateaux est fait',
            sailFrequency: '<strong>A quelle fréquence</strong> utilisez -vous votre bateau\t\n',
            paintLocation: 'OU PEIGNEZ VOUS VOTRE BATEAU',
            waterType: "Dans quel type <strong>d'eau utilisez-vous votre</strong> bateau?"
        },
        answers: {
            help: 'I need help chosing antifouling',
            type: [
                {
                    label: 'Voilier',
                    icon: 'sailingBoat',
                    value: 'sailing'
                },
                {
                    label: 'Bateau à moteur (lent)',
                    sublabel: "jusqu'à 20 nœuds",
                    icon: 'motorboatSlow',
                    value: 'motor-slow'
                },
                {
                    label: 'Bateau à moteur (rapide)',
                    sublabel: 'plus rapide que 20 nœuds',
                    icon: 'motorboatFast',
                    value: 'motor-fast'
                }
            ],
            material: [
                {
                    label: 'Polyester',
                    value: 'plastic'
                },
                {
                    label: 'Acier',
                    value: 'iron'
                },
                {
                    label: 'Bois',
                    value: 'wood'
                },
                {
                    label: 'L’aluminium',
                    value: 'aluminium'
                }
            ],
            sailFrequency: [
                {
                    label: 'Rare',
                    sublabel: '1-2 fois par mois ou moins',
                    value: 'low'
                },
                {
                    label: 'Souvent',
                    sublabel: '1-2 fois par semaine',
                    value: 'medium'
                },
                {
                    label: 'Très Souvent',
                    sublabel: 'presque tous les jours',
                    value: 'high'
                }
            ],
            paintLocation: [
                {
                    label: 'Sélectionnez pays',
                    countries: [
                        { label: 'UK', value: 'en-GB' },
                        { label: 'US', value: 'en-US' },
                        { label: 'Canada', value: 'en-CA' },
                        { label: 'Denmark', value: 'da-DK' },
                        { label: 'Spain', value: 'es-ES' },
                        { label: 'Finland', value: 'fi-FI' },
                        { label: 'Germany', value: 'de-DE' },
                        { label: 'Greece', value: 'el-GR' },
                        { label: 'Croatia', value: 'hr-HR' },
                        { label: 'Norway', value: 'nb-NO' },
                        { label: 'Netherlands', value: 'nl-NL' },
                        { label: 'Sweden - East Coast', value: 'sv-SE_e' },
                        { label: 'Sweden - West Coast', value: 'sv-SE_w' },
                        { label: 'Sweden - Lakes', value: 'sv-SE_l' },
                        { label: 'France', value: 'fr-FR' }
                    ]
                }
            ],
            waterType: [
                { label: 'Sea/Ocean', value: 'sea/ocean' },
                { label: 'River', value: 'rivers' },
                { label: 'Lakes', value: 'lakes' }
            ]
        },
        result: {
            heading: 'Nous recommandons',
            selection: {
                title: 'Votre sélection',
                type: 'TYPE DE BATEAU',
                waterType: 'Type d’eau',
                material: 'Matière',
                sailFrequency: 'Activité',
                country: 'Pays'
            },
            category: {
                premium: 'Premium',
                alternative: 'Sans Biocide Premium/ Haut de gamme',
                bestBuy: 'Meilleur achat',
                economic: 'Economic',
                bestBuyAlternative: 'Biocide-free Best buy',
                economicAlternative: 'Biocide-free Economic'
            },
            findOutMore: 'En savoir plus',
            whereToBuy: 'Ou Acheter',
            email: 'Email',
            send: 'Send',
            feedback: {
                title: 'Est ce que cette information a été utile?',
                yes: 'Yes',
                no: 'No',
                comment: 'Comment',
                placeholder: 'Enter your comment here'
            },
            recommendation: {
                title: 'Envoyer la recommendation par email'
            },
            calculateVolume: 'Calculer le volume'
        }
    },
    calculate: {
        letsCalculate: 'Calculons',
        questions: {
            antifouling: "Choisir l'antifouling",
            keelType: 'Sélectionnez le type de <strong>quille de votre bateau</strong>',
            dimensions: 'Entrez les <strong>dimensions</strong> de la surface sous marine'
        },
        answers: {
            keelType: [
                {
                    label: 'Dérive',
                    icon: 'finKeel',
                    value: 'fin'
                },
                {
                    label: 'Quille intégrale',
                    icon: 'fullKeel',
                    value: 'full'
                }
            ],
            dimensionTitles: [
                {
                    title: 'Dimensions personnalisées'
                },
                {
                    title: 'Entrez les dimensions de la surface sous marine'
                }
            ],
            dimensions: [
                {
                    type: 'unit',
                    label: 'Unités',
                    values: [{ label: 'Mètres', value: 'm' }, { label: 'Pieds', value: 'f' }]
                },
                {
                    type: 'waterline',
                    label: 'Longueur de la ligne de flottaison'
                },
                {
                    type: 'beam',
                    label: 'Largeur'
                },
                {
                    type: 'draft',
                    label: 'Tirant d’eau'
                },
                {
                    type: 'm2',
                    label: 'm2'
                }
            ]
        },
        result: {
            heading: 'Volume requis pour 1 couche',
            // headingTwoCoats: 'Volume requis pour 2 couches',
            selection: {
                title: 'Votre sélection',
                antifouling: 'Antifouling',
                type: 'TYPE DE BATEAU',
                waterType: 'Type d’eau',
                material: 'Matière',
                sailFrequency: 'Activité',
                country: 'Pays',
                keelType: 'Le type de quille',
                dimensions: 'Dimensions du bateau'
            },
            category: {
                premium: 'Premium',
                alternative: 'Biocide-free Premium',
                bestBuy: 'Best buy',
                economic: 'Economic',
                bestBuyAlternative: 'Biocide-free Best buy',
                economicAlternative: 'Biocide-free Economic'
            },
            suggestedAmount: 'Montant suggéré',
            suggestedAmountTwoCoats: 'Montant suggéré (2 couches)',
            oneCoat: '(1 couche)',
            fiveCoats: '(5 couches)',

            primerAltTiecoatSilic: "N'oubliez pas d'utiliser également Tiecoat!",
            primerAltSilicSealSilic:
                '<strong>CASE 2</strong><br/>Bateaux déjà traités – Application sur un ancien antifouling en bon état – passage facile à Silic One System',
            primerAlLightSilic:
                "<strong>CASE 1</strong><br/>Retrait de l'ancien antifouling - application d'un système complet & d'un nouveau bateau sans époxy",

            primerAltTiecoat: 'N’oubliez pas de toujours utilisé un Tiecoat!',
            primerAltSilicSeal:
                '<strong>CAS 1</strong><br/>Décapage de l’ancien antifouling et application du système complet',
            primerAlLight:
                '<strong>CAS 2</strong><br/>Application sur un ancien antifouling en bon état – passage facile à Silic One System',
            primer:
                '<strong>Le corps</strong> du bateau est fortement <strong>endommagé</strong> ou vous peignez <strong>la première fois</strong>? Peut-être aurez vous besoin',
            whereToBuy: 'POINTS DE VENTE',
            email: 'Email',
            send: 'Send',
            or: 'OR',
            feedback: {
                title: 'Est ce que cette information a été utile?',
                yes: 'Yes',
                no: 'No',
                comment: 'Comment',
                placeholder: 'Enter your comment here'
            },
            recommendation: {
                title: 'Envoyer la recommendation par email'
            },
            calculateVolume: 'Calculate volume'
        }
    },
    map: {
        country: 'Country',
        city: 'City',
        getDirections: 'Get directions',
        placeholder: 'All cities...'
    },
    footer: 'Hempel Yacht - Everything you need to know about yacht painting.'
}
